module.exports = __webpack_public_path__ + "c3afcbf3ebf526d0328cc2f18ca7ccb5.jpg";